/* One scroll clock for the entire storefront. Native scrolling, no scroll interception. */
(() => {
  'use strict';
  const root = document.documentElement;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = (n, a = 0, b = 1) => Math.max(a, Math.min(b, n));
  const lerp = (a, b, p) => a + (b - a) * p;
  const samples = [1,8,14,18,24,30,31,33,35,37,39,41,43,46,49,52,55,58,61,64,67,70,74,78,82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,118,120];
  // Screen-space azimuth follows the fixed Blender camera; elevation shortens shadows at noon.
  const sunKeys = [[1,-6,250],[12,-6,250],[18,-16,270],[30,-18,80],[31,-4,110],[42,4,110],[43,15,110],[66,35,130],[67,70,180],[84,70,180],[85,20,240],[102,12,245],[103,4,250],[120,-6,250]];
  const hours = [[0,21],[3,24],[5,29],[8,30],[12,32],[20,36],[24,39],[34,43],[43,45]];
  const palettes = [[0,4,3,2],[5,4,3,2],[8,87,67,57],[12,223,207,175],[20,244,238,226],[24,238,222,194],[29,218,188,150],[34,112,78,59],[43,4,3,2]];
  const interpolate = (keys, x) => {
    const index = Math.max(0, keys.findIndex((key, i) => i < keys.length - 1 && x <= keys[i + 1][0]));
    const a = x >= keys.at(-1)[0] ? keys.at(-1) : keys[index], b = keys[Math.min(keys.length - 1,index + 1)];
    const p = a === keys.at(-1) ? 0 : clamp((x - a[0]) / (b[0] - a[0]));
    return a.slice(1).map((value, i) => lerp(value, b[i + 1], p));
  };
  let anchors = [], frame = 0, target = 0, raf = 0, fixed = reduced.matches, userFixed = false;
  const home = !!document.querySelector('.hero');
  if(home)root.classList.add('solar-home');
  const clock = document.querySelector('[data-solar-clock]');
  const time = clock?.querySelector('[data-solar-time]');
  const phase = clock?.querySelector('[data-solar-phase]');
  const toggle = document.querySelector('[data-motion-toggle]');
  const dot = clock?.querySelector('[data-solar-dot]');
  const needle = clock?.querySelector('[data-solar-needle]');
  let visibleText = [], titleText = [];
  const textObserver = new IntersectionObserver(entries => entries.forEach(entry => {
    entry.target.classList.toggle('solar-visible', entry.isIntersecting);
  }), { rootMargin: '80px' });
  const skyObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
    entry.target.dataset.skyVisible=String(entry.isIntersecting);
  }));
  function observeSkies(){skyObserver.disconnect();document.querySelectorAll('.night-sky').forEach(el=>skyObserver.observe(el));}
  function observeText() {
    textObserver.disconnect();
    visibleText = [...document.querySelectorAll('main :is(h1,h2,h3,p,li,summary,figcaption,.eyebrow,.price,.text-link),.site-footer a')];
    titleText = [...document.querySelectorAll('main h1,main h2,main h3')];
    visibleText.forEach(el => { el.classList.add('solar-text'); textObserver.observe(el); });
    titleText.forEach(el => el.classList.add('solar-heading'));
  }
  function measure() {
    const max = Math.max(1, document.documentElement.scrollHeight - innerHeight);
    const top = el => el.getBoundingClientRect().top + scrollY;
    if (home) {
      anchors = [[0,0]];
      const cycle = document.querySelector('.light-cycle:not([data-compact])');
      if(cycle){anchors.push([top(cycle),2]);anchors.push([top(cycle)+Math.max(1,cycle.offsetHeight-innerHeight),12]);}
      for (const [selector, value] of [['#le-film',12],['#fonctionnement',15],['#comprendre',18],['#choisir',20],['.faq-section',29],['.closing',35]]) {
        const el = document.querySelector(selector); if(el)anchors.push([Math.min(max,top(el)-innerHeight*.16),value]);
      }
      anchors.push([max,43]);
      anchors.sort((a,b)=>a[0]-b[0]);
      // Editor reordering remains monotonic rather than making the sun jump backwards.
      anchors = anchors.filter((a,i,all)=>!i || a[0]>all[i-1][0]+1);
      anchors.forEach((a,i)=>{if(i)a[1]=Math.max(a[1],anchors[i-1][1]);});
    } else anchors = [[0,12],[max,33]];
    fromScroll();
  }
  function fromScroll() {
    if(fixed)return;
    target=interpolate(anchors,scrollY)[0]; schedule();
  }
  function schedule() { if(!raf&&!document.hidden)raf=requestAnimationFrame(tick); }
  function tick() {
    raf=0;
    const delta=target-frame;
    // Brief easing avoids light jumps, then stops completely while reading.
    frame+=Math.abs(delta)<.012?delta:Math.sign(delta)*Math.min(.65,Math.abs(delta)*.24);
    paint(frame);
    if(Math.abs(target-frame)>.001)schedule();
  }
  function paint(value) {
    const low=Math.floor(value), high=Math.min(43,Math.ceil(value));
    const timeline=lerp(samples[low],samples[high],value-low);
    const [elevation,azimuth]=interpolate(sunKeys,timeline);
    const strength=clamp((elevation+12)/35);
    const length=lerp(32,5,clamp(elevation/75));
    const direction=clamp((azimuth-180)/70,-1,1);
    const x=direction*length, y=7+length*.28;
    const bg=interpolate(palettes,value).map(Math.round);
    const linear=bg.map(n=>{n/=255;return n<=.04045?n/12.92:((n+.055)/1.055)**2.4;});
    const lum=linear[0]*.2126+linear[1]*.7152+linear[2]*.0722;
    const dark=lum<.179;
    const ink=lum<.10?'#f5ecdc':dark?'#ffffff':lum<.25?'#040302':'#1c1814';
    const muted=lum<.10?'#e7d9c4':lum<.5?ink:'#504337';
    const vars={
      '--solar-x':`${x.toFixed(2)}px`,'--solar-y':`${y.toFixed(2)}px`,
      '--solar-small-x':`${(x*.065).toFixed(2)}px`,'--solar-small-y':`${(y*.08).toFixed(2)}px`,
      '--solar-mid-x':`${(x*.48).toFixed(2)}px`,'--solar-mid-y':`${(y*.48).toFixed(2)}px`,
      '--solar-blur':`${lerp(5,2,clamp(elevation/70)).toFixed(1)}px`,
      '--solar-shadow':`rgba(35,18,9,${(.10+strength*.065).toFixed(3)})`,
      '--solar-soft-shadow':`rgba(35,18,9,${(.055+strength*.04).toFixed(3)})`,
      '--solar-bg':`rgb(${bg.join(' ')})`,'--solar-ink':ink,
      '--solar-muted':muted,'--solar-line':dark?'rgba(245,236,220,.3)':'rgba(28,24,20,.23)',
      '--solar-sun-x':`${(50-direction*60).toFixed(2)}%`,'--solar-sun-y':`${(70-elevation).toFixed(2)}%`,
      '--solar-warmth':(lum>.1&&lum<.3?0:strength*.05).toFixed(3),'--solar-angle':`${(direction*34).toFixed(2)}deg`,
      '--solar-progress':(value/43).toFixed(5),
      '--sky-opacity':(value<10?clamp((10-value)/3):value>35?clamp((value-35)/8):0).toFixed(3),
      '--sky-rotation':`${(value*4).toFixed(2)}deg`,
      '--floor-shadow-opacity':(.06+strength*.14).toFixed(3),
      '--floor-shadow-angle':`${(direction*11).toFixed(2)}deg`
    };
    for(const [key,v]of Object.entries(vars))root.style.setProperty(key,v);

    root.dataset.solarFrame=value.toFixed(3);root.dataset.solarTone=dark?'dark':'light';
    root.dataset.skyActive=String(Number(vars['--sky-opacity'])>0);
    const hour=interpolate(hours,value)[0];
    const minute=Math.round(hour*60)%1440;
    const label=`${String(Math.floor(minute/60)).padStart(2,'0')}:${String(minute%60).padStart(2,'0')}`;
    const name=value<3?window.DM.ui.s0e037c75f5c9:value<7?'Nuit':value<12?'Aube':value<20?'Matin':value<24?'Midi':value<33?window.DM.ui.s16a97fa6d86e:'Soir';
    if(time){time.textContent=label;time.dateTime=label;phase.textContent=fixed?window.DM.ui.s8681a75a0bc8:name;}
    document.querySelectorAll('[data-solar-hour]').forEach(el=>{el.textContent=label;});
    if(dot){const angle=(value/43)*Math.PI*2-Math.PI/2;dot.setAttribute('cx',(24+19*Math.cos(angle)).toFixed(2));dot.setAttribute('cy',(24+19*Math.sin(angle)).toFixed(2));needle.setAttribute('x2',(24+13*Math.cos(angle)).toFixed(2));needle.setAttribute('y2',(24+13*Math.sin(angle)).toFixed(2));}
    window.DMSun.frame=value;
    window.DMSun.state={frame:value,hour,label,phase:name,fixed};
    document.dispatchEvent(new CustomEvent('dm:time',{detail:window.DMSun.state}));
  }
  function setFixed(value) {
    fixed=value;root.dataset.solarFixed=String(value);
    if(toggle){toggle.setAttribute('aria-pressed',String(value));toggle.textContent=value?window.DM.ui.s7c32ad7b52ea:window.DM.ui.s7a568de55170;}
    if(value){cancelAnimationFrame(raf);raf=0;target=frame;paint(frame);}else fromScroll();
  }
  window.DMSun={frame:0,setFrame(value){target=clamp(value,0,43);if(fixed){frame=target;paint(frame);}else schedule();}};
  toggle?.addEventListener('click',()=>{userFixed=!fixed;setFixed(!fixed);});
  addEventListener('scroll',fromScroll,{passive:true});addEventListener('resize',measure,{passive:true});
  reduced.addEventListener('change',()=>{if(reduced.matches){frame=20;target=20;setFixed(true);}else setFixed(userFixed);});
  document.addEventListener('visibilitychange',()=>{root.dataset.solarHidden=String(document.hidden);if(document.hidden){cancelAnimationFrame(raf);raf=0;}else schedule();});
  document.addEventListener('shopify:section:load',()=>{observeText();observeSkies();measure();});
  document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(()=>{observeSkies();measure();}));
  document.addEventListener('shopify:section:reorder',measure);
  // Respect Shopify’s preview toolbar without hiding or changing it.
  let previewBar;
  const previewInset=()=>{const r=previewBar?.getBoundingClientRect();const h=r&&r.bottom>=innerHeight-2&&r.height<innerHeight*.45?r.height:0;root.style.setProperty('--shopify-preview-inset',`${h}px`);};
  const findPreviewBar=()=>{const el=document.getElementById('PBarNextFrameWrapper');if(!el||el===previewBar)return;previewBar=el;new ResizeObserver(previewInset).observe(el);el.addEventListener('toggle',previewInset);previewInset();};
  if(window.Shopify?.theme?.role==='unpublished'||window.Shopify?.designMode){findPreviewBar();new MutationObserver(findPreviewBar).observe(document.body,{childList:true});addEventListener('resize',previewInset,{passive:true});}
  root.classList.add('solar-ready');if(clock)clock.hidden=false;
  observeText();observeSkies();measure();frame=fixed?20:target;paint(frame);setFixed(fixed);
  new ResizeObserver(measure).observe(document.querySelector('main'));
  document.fonts.ready.then(measure);
})();
